module.exports = __webpack_public_path__ + "static/media/arrow-slide-izq.8f853e0e.svg";